import React from "react";
import { Grid2, useMediaQuery } from "@mui/material";
import BackgroundImage from "/Images/Background.svg";
import Bapepti from "/Images/Mask group.svg";
import Kominfo from "/Images/komdigi-white.png";
import ojk from "/Images/ojk-white.png";
import depository from "/Images/depository-white.png";
import Lottie from "react-lottie";


const HeroSection = () => {
  // Check if screen is mobile-sized (max-width: 767px)
  const isMobile = useMediaQuery("(max-width: 767px)");
  const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const styles = {
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.875rem" : "1rem",
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
    },
  };
  return (
    <section
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: isMobile ? "0 2.5rem" : "0 6rem",
        paddingTop: isMobile ? "6rem" : "12rem",
        paddingBottom: isMobile ? "6rem" : "12rem",
        minHeight: isMobile ? "450px" : "820px",
        color: "#FFFFFF",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Depository logo background, 70% transparent */}
      <img
        src={depository}
        alt="depository background"
        style={{
          position: "absolute",
          top: "50%",
          left: "80%",
          transform: "translate(-50%, -50%)",
          opacity: 0.3,
          width: isMobile ? "60vw" : "35vw",
          maxWidth: "700px",
          minWidth: "200px",
          zIndex: 0,
          pointerEvents: "none",
          userSelect: "none",
        }}
        aria-hidden="true"
      />
      <Grid2 container spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid2 size={6} md={6} paddingLeft={{ md: 0, lg: 0 }}>
          <div
            style={{
              marginBottom: "30px",
            }}
          >
          </div>
          <h1
            style={{
              fontSize: isMobile ? "24px" : "50px",
              fontWeight: 550, // Semi-bold
              lineHeight: "1.2",
              marginBottom: isMobile ? "20px" : "50px",
            }}
          >
            <span style={{ color: "#F4E37B" }}> The Solutions You Need </span>
            <br />
            Right at Your Fingertips
            <br />
          </h1>

          {/* Subtitle */}
          <p
            style={{
              fontSize: isMobile ? "14px" : "22px",
              color: "#E7E4E2",
              marginBottom: isMobile ? "24px" : "40px",
              minWidth: isMobile ? "auto" : "762px",
            }}
          >
            We provide advanced technology solutions to secure
            <br />
            and manage digital assets for everyone{" "}
          </p>
          <div
            style={{
              display: "none",
              alignItems: "center",
              gap: "0.5rem",
              fontSize: isMobile ? "14px" : "20px",
              color: "#6D6D6D",
              flexDirection: "row",
              flexWrap: "nowrap",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <span
              style={{
                fontWeight: "medium",
                color: "#fff",
                fontSize: isMobile ? "16px" : "25px",
              }}
            >
              Licensed by
            </span>
            <img
              src={ojk}
              alt="ojk Logo"
              style={{ height: isMobile ? "25px" : "48px" }}
            />
            <img
              src={Bapepti}
              alt="Bappebti Logo"
              style={{
                height: isMobile ? "25px" : "48px",
              }}
            />
            <img
              src={Kominfo}
              alt="Kominfo Logo"
              style={{ height: isMobile ? "25px" : "48px" }}
            />
          </div>
        </Grid2>
        <Grid2 size="auto" md={6} paddingRight={{ md: 0, lg: 24 }}>
          <div >
            <img
              src={depository}
              alt="depository Logo"
              style={{ height: isMobile ? "128px" : "256px" }}
            />
          </div>
        </Grid2>
      </Grid2>
    </section>
  );
};

export default HeroSection;
